import { Component, OnInit, Output, EventEmitter, Input, HostListener } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Constant, ContentTypeValues } from "src/app/common/constant/constant";
import { CommonService } from 'src/app/services/common/common.service';
import { RepairOrderService } from "src/app/services/repair-order/repair-order.service";
import { ProductMatrixService } from "src/app/services/product-matrix/product-matrix.service";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';

@Component({
  selector: 'app-assigned-tech',
  templateUrl: './assigned-tech.component.html',
  styleUrls: ['./assigned-tech.component.scss']
})
export class AssignedTechComponent implements OnInit {
  @Input() title: string = "Title";
  @Input() height: number;
  @Input() apiData: any = {};
  @Input() type: any = 'assign';
  @Input() selectType: any = 'single'; // 'single' or 'multiple'
  @Input() defaultType: any = 1;
  @Input() defaultSelectedId: 0;
  @Output() selectedItems: EventEmitter<any> = new EventEmitter();
  
  assignTypes: any = [{id: 1, name: 'Internal Users', active: false, class: 'internal'}, {id: 2, name: 'Distributors', active: false, class: 'external'}]
  listItems: any[] = [];
  internalListItems: any[] = [];
  externalListItems: any[] = [];
  selectedList: any[] = [];

  public user: any;
  public domainId;
  public userId;
  public roleId;
  public activeAssignType: any = 1;

  itemLimit = 20;
  itemOffset = 0;
  itemTotal = 0;

  empty: boolean = false;
  public loading = false;
  public isLoadingMore = false;
  private scrollContainer: HTMLElement;

  private handleEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      console.log('Escape key pressed');
      this.activeModal.dismiss("Cross click");
    }
  };

  constructor(
    private authenticationService: AuthenticationService,
    public activeModal: NgbActiveModal,
    private commonApi: CommonService,
    private repairOrderApi: RepairOrderService,
    private LandingpagewidgetsAPI: LandingpageService,
  ) { }

  ngOnInit(): void {
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;

    let typeIndex = this.assignTypes.findIndex(option => option.id == this.defaultType);
    typeIndex = (typeIndex < 0) ? 0 : typeIndex;
    this.activeAssignType = this.assignTypes[typeIndex].id;
    this.assignTypes[typeIndex].active = true;

    this.getInternalUserList();

    setTimeout(() => {
      this.scrollContainer = document.getElementById('manageTable');
      if (this.scrollContainer) {
        this.scrollContainer.addEventListener('scroll', this.onScroll.bind(this));
      }
    }, 100);

    document.addEventListener('keydown', this.handleEscape);
  }

  onScroll(event: any): void {  
    if (this.itemTotal <= this.listItems?.length  || this.isLoadingMore) {
      return;
    }
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    console.log("onScroll: ", {atBottom});
    if (atBottom) {
      //this.loadItems(true);
    }
  }

  getInternalUserList() {
    this.internalListItems = [];
    const apiInfo = {
        apiKey: Constant.ApiKey,
        domainId: this.domainId,
        userId: this.userId,
    };
    this.LandingpagewidgetsAPI.apiSalesRepList(apiInfo).subscribe((response) => {
        console.log(response);
        const responseData = response.data;
        let items = (responseData?.items) ? responseData.items : [];
        this.empty = (items.length > 0) ? false : true;
        this.internalListItems = items;
    });
  }

  getExternalUserList() {
    this.externalListItems = [];
    let type = 'list';
    let FiltersArr = {
      domainId: this.domainId,
      networkIdInt: this.domainId,
      isActiveShopInt: 1
    };
    let objData = {
      sortField: "shopnameStr",
      sortOrder: "asc",
      userId: this.userId,
      platform: 3,
      type: 13,
      listing: 1,
      rows: 100,
      start: 0,
      filters: FiltersArr
    };    
    
    this.commonApi.getROSolr(type, objData).subscribe(response => {
      console.log(response)
      let items = response.shopItems;
      this.empty = (items.length > 0) ? false : true;
      items.forEach(item => {
        let id = item.shopIdInt;
        let name = item.shopnameStr;
        let profile = item.profileImageStr;
        let type = item.shopTypeNameStr;
        this.externalListItems.push({id, name, profile, type});
      });      
    });
  }

  loadItems(push: boolean = false) {

  }

  switchTab(item) {
    let id = item.id;
    this.assignTypes.forEach(type => {
      if(type.id != id) {
        type.active = false;
      } else {
        type.active = true;
        this.activeAssignType = id;
      }
    });
    switch(id) {
      case 1:
        this.getInternalUserList();
        break;
      case 2:
        this.getExternalUserList();
        break;  
    }
  }

  assign(techId) {
    let assignType = this.activeAssignType;
    let emitData = {
      assignType,
      techId
    }
    this.selectedItems.emit(emitData);
    this.activeModal.dismiss("Cross click");
  }

  close() {
    // this.selectedItems.emit(this.selectedList);
    this.activeModal.dismiss("Cross click");
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleEscape);
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.onScroll.bind(this));
    }
  }

}
